module.exports = __webpack_public_path__ + "img/notifyPackage.f6eb6c8f.svg";